const ngRoll = [ '$rootScope', '$modules', function ($rootScope, $modules) {
    return {
        /**
         * @param $scope
         * @param $item
         * @param $params {{ ngRoll: string }}
         */

        link: function ( $scope, $item, $params ) {
            let $self = $item[0];

            $self.addEventListener('mouseenter', function (event) {
                if ( $modules.hover ) {
                    $modules.enter($params.ngRoll)
                }
            });

            $self.addEventListener('mouseleave', function (event) {
                if ( $modules.hover ) {
                    $modules.leave( function () {
                        $scope.$apply();
                    });
                }
            });

            $scope.$watch('modules.display', function () {
                if ( $modules.visible($params.ngRoll) === true ) {
                    $item.removeClass('ng-hide');
                } else {
                    $item.addClass('ng-hide');
                }
            }, true );

        }
    }
}];

export default ngRoll;
